import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskOrganizationDetailsRoute: InvariantJiraRoute = {
	name: 'servicedesk-organization-details',
	path: '/jira/servicedesk/projects/:projectKey/organizations/:organizationId',
	exact: true,
};
